import React, { Component } from 'react'
import DataGrid from "../../components/DataGrid";
// import Pagination from "../../components/Pagination";
// import FinancialBox from "../../components/boxes/FinancialBox";
import ProductViewBox from './ProductViewBox';
// import SidebarView from '../../components/SidebarView';
import { checkTranslation, imageAddress, priceStandardView, translate } from '../../utils/useful';
// import Collapsible from 'react-collapsible';
// import Responsive from '../../components/Responsive';
// import Monitor from "../../windows/DeskViews/Monitor";
// import HttpServices from '../../utils/Http.services';
// import FixedView from '../../components/FixedView';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from "../../stores/actionsList";
import CommerceUserToolbar from '../../components/header/CommerceUserToolbar';
import Slider from '../../components/slider/Slider';

class ProductsView extends Component {
    state = {
        showCollapse: null,
        active: false,
        selected: null,
        myProducts: [],
        cselect: [0],
        myCategories: [],
        show: false,
        product: [],
        filter: [
            { name: '{{lang}}Categories' },
            { name: '{{lang}}Brand' },
            { name: '{{lang}}Price' },
        ],
        option: [],

        categories: [],
        category: null,

        products: []

    }

    componentDidMount() {

        if (this.props.setHeader) {

            this.props.setHeader({
                'toolbar': this.toolbarView,
                showToolbar: true,
            })

        }
    }


    toolbarView = () => {
        return (
            <CommerceUserToolbar showStack={this.state.showStack} functionsHandler={this.toolbarFunctionsHandler} colors={this.props.colors} language={this.props.language} width={this.props.width} />
        )
    }


    // fetchMyProducts = () => {
    //     this.setState({ isLoadingData: true })
    //     HttpServices.request('getProducts', {}, (fetchResult, fetchError, fetchStatus) => {
    //         console.log(fetchResult.info, 'getProducts')
    //         this.setState({ isLoadingData: false })

    //         if (fetchError) {
    //             // console.log('fetchError', fetchError)
    //             return
    //         }
    //         // console.log('My product', fetchResult.info)
    //         this.setState({ myProducts: fetchResult.info })
    //     })
    // }
    // getCart = () => {
    //     // console.log('first')
    //     this.setState({ isLoadingData: true })
    //     HttpServices.request('addToCart', {}, (fetchResult, fetchError, fetchStatus) => {
    //         this.setState({ isLoadingData: false })

    //         console.log('fetchError', fetchError)
    //         if (fetchError) {
    //             this.setState({ cart: fetchError.cart }, () => {
    //                 // this.checkCart()
    //             })
    //             return
    //         }
    //         console.log('My productttttttttttttttttt', fetchResult)
    //         this.setState({ cart: fetchResult.cart, totalCount: fetchResult.totalCount, totalPrice: fetchResult.totalPrice }, () => {
    //             // this.checkCart()
    //             console.log('object', this.state.cart);
    //         })
    //     })
    // }
    // checkCart = () => {
    //     console.log('herreeeee')
    //     // let exist = false
    //     let productCount = 0
    //     for (let i = 0; i < this.state.cart.products.length; i++) {
    //         const element = this.state.cart.products[i];
    //         if (element.product._id == this.state.product._id) {
    //             console.log('llllllllll', element);
    //             // exist = true
    //             productCount =productCount+ element.count
    //         }
    //     }
    //     // console.log('object', exist);
    //     this.setState({ productCount })
    //     // if(exist = false){
    //     // }
    // }

    // fetchMyCategories = () => {

    //     let body = {
    //         applet: this.props.variables?.appletId,
    //         appletHub: this.props.variables?.appletHub,

    //     }
    //     // console.log(body, 'body=====')
    //     HttpServices.request("getProductsCategories", body, (fetchResult, fetchError) => {
    //         if (fetchError) {
    //             console.log("fetchError", fetchError)
    //             return
    //         }
    //         console.log("my categories", fetchResult)
    //         this.setState({ myCategories: fetchResult.info })
    //     })
    // }

    // openSidebar = () => {
    //     this.sidebarView.openSidebar()
    // }
    handleCollapse = (index) => {
        if (this.state.showCollapse == index) {
            this.setState({ active: !this.state.active })
        } else {
            this.setState({ showCollapse: index, active: true })
        }
    }

    // openMenu = (index) => {
    //     this.setState({ category: index })
    // }

    openFirstView = () => {
        this.firstView.showView()
    }

    // changeWindow=(pathExtra)=>{
    //     // let path = [this.props.variables]
    //     this.props.changeWindow('applet', { path: path })
    // }

    changePage = (page, link) => {

        console.log("changePage",page,link)
        this.props.changePage(['product',page])
        // this.props.changeWindowLink(link)
    }

    render() {
        return (
            <div className='h-100 w-100 scroll-no-scrollbar'>

                <div>
                    <Slider />
                </div>

                {/* <div className='pb-1'>
                    <div className='flexc sc-gray-mx px-3 py-3' style={{ overflow: 'auto' }}>
                        {Array.isArray(this.props.myCategories) && this.props.myCategories.map((prop, index) => {
                            return (
                                <button className=' mrd-2 categories-tab br-30'>
                                    <div className='flexc px-3 '>
                                        <img src='/assets/icons/all.svg' />
                                        <p className='main-c2'>{checkTranslation(prop.name)}</p>
                                    </div>
                                </button>
                            )
                        })}
                    </div>
                </div> */}


                <div className='pl-3 mt-3' style={{ borderBottom: '1px solid #eee' }}>
                    <p className='font-size-22 weight-700 '>Featured items</p>
                    <div className='h-100 w-100 py-3'>
                        <DataGrid marginBottom={'my-2 flex-1'} width={this.props.width} onClick={this.changePage} changePage={this.props.changePage} isLoading={this.state.isLoadingData} data={this.props.myProducts} component={ProductViewBox} col={this.props.page?.grid ?? { xs: "12", sm: '6', md: '3', lg: "3", xl: "2" }} settings={{ edit: (this.props.page?.actions && Object.keys(this.props.page?.actions).length) > 0 ? true : false, openOptions: this.openOptions, changePage: this.props.changePage, baseUrl: [...this.props.baseUrl], }} />
                    </div>
                </div>
                <div className='pl-3 mt-3' style={{ borderBottom: '1px solid #eee' }}>
                    <p className='font-size-16 weight-700 main-c5'>On Sale</p>
                    <div className='h-100 w-100 py-3'>
                        <DataGrid marginBottom={'my-2 flex-1'} width={this.props.width} onClick={this.changePage} changePage={this.props.changePage} isLoading={this.state.isLoadingData} data={this.props.myProducts} component={ProductViewBox} col={this.props.page?.grid ?? { xs: "12", sm: '6', md: '3', lg: "3", xl: "2" }} settings={{ edit: (this.props.page?.actions && Object.keys(this.props.page?.actions).length) > 0 ? true : false, openOptions: this.openOptions, changePage: this.props.changePage, baseUrl: [...this.props.baseUrl], }} />
                    </div>
                </div>
                <div className='pl-3 mt-3' style={{ borderBottom: '1px solid #eee' }}>
                    <p className='font-size-16 weight-700 main-c5'>Most Viewed</p>
                    <div className='h-100 w-100 py-3'>
                        <DataGrid marginBottom={'my-2 flex-1'} width={this.props.width} onClick={this.changePage} changePage={this.props.changePage} isLoading={this.state.isLoadingData} data={this.props.myProducts} component={ProductViewBox} col={this.props.page?.grid ?? { xs: "12", sm: '6', md: '3', lg: "3", xl: "2" }} settings={{ edit: (this.props.page?.actions && Object.keys(this.props.page?.actions).length) > 0 ? true : false, openOptions: this.openOptions, changePage: this.props.changePage, baseUrl: [...this.props.baseUrl], }} />
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(ProductsView);
